<template>
    <main>
        <div class="expool">
            <div class="title">
                <div class="right">
                    <div>
                        <p>题库名称：<span v-text="exercisePoolName" :title="exercisePoolName"></span></p>
                        <p>题库ID：<span v-text="exercisePoolId" :title="exercisePoolId"></span></p>
                        <p>已录题数：<span v-text="exercisePoolExcount" :title="exercisePoolExcount"></span></p>
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="contentMain">
                    <questionUpload></questionUpload>
                </div>
                
            </div>
        </div>
    </main>
</template>
<script>

import questionUpload from '../../components/uploading/questionUpload.vue'
export default {
    components: {
        questionUpload
    },
    created(){
        this.$emit("header", false);
    }
}
</script>

<style lang="sass" src="../../static/Modal.sass" rel="stylesheet/sass"></style>
<style lang="sass" src="../../static/Loading.sass" rel="stylesheet/sass"></style>
<style src="../expool/expool.sass" lang="sass" rel="stylesheet/sass" scoped></style>
<style scoped lang="scss">
    .contentMain{
        width: 100%;
        padding: 0 10px;
    }
</style>

